import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-base"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupBase',
  props: {
    open: { type: Boolean }
  },
  emits: ['update:open'],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "popup-mask",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:open',false)))
        }),
        _createElementVNode("div", _mergeProps({
          class: ["popup-box", {show:_ctx.open}]
        }, _ctx.$attrs), [
          _renderSlot(_ctx.$slots, "default")
        ], 16)
      ]))
    : _createCommentVNode("", true)
}
}

})